// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"1e2fde14","309":"d0d965fb","353":"66de2cd0","460":"9fac540c","817":"39aad56e","939":"8d04867f"}[chunkId] + ".chunk.js";
};